import React from "react";
import moment from "moment";
import { Modal } from "antd";
import { IconExclamation } from "./Icons";
const { confirm } = Modal;

function SuppliersInvoices(props) {
  console.log("SuppliersInvoices", props);
  const parseTypeOptions = [
    { value: "ai_text", label: "AI text" },
    { value: "ai_pdf", label: "AI PDF" },
    { value: "azure", label: "Azure" },
    { value: "azure_ai", label: "Azure + AI" },
  ];

  const exportInvoice = () => {
    const hasMissingItemCodeRivile = props.supplier_invoice_items.some(
      (item) => !item.item_code_rivile
    );

    if (hasMissingItemCodeRivile) {
      confirm({
        title: "Are you sure?",
        icon: <IconExclamation className="text-primary" />,
        content:
          "Products, without assigned rivile code will be created as new products.",
        onOk() {
          props.exportInvoice();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      props.exportInvoice();
    }
  };

  const parseInvoice = (parseTypeOption = null) => {
    const parseType = showParseTypeDropdown ? parseTypeOption : null;
    if (true) {
      confirm({
        title: "Are you sure?",
        icon: <IconExclamation className="text-primary" />,
        content:
          "Invoice will be parsed from PDF file and update current one. Continue?",
        onOk() {
          props.parseInvoice(parseType);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      props.parseInvoice(parseType);
    }
  };

  let showImportBtn =
    !props.exported &&
    props.store.props.store != null &&
    props.store.props.store != undefined;
  
  let showParseBtn =
    !props.exported &&
    props.suppliers_invoices_document_id != null

  const hasPdfPreview =
    props.suppliers_invoices_document_id != null &&
    props.suppliers_invoice_download_url;

  const showParseTypeDropdown =
    showParseBtn &&
    !props.regex_parse;

  const waitForElement = (id, callback) => {
    var poops = setInterval(function () {
      if (document.getElementById(id)) {
        clearInterval(poops);
        callback();
      }
    }, 100);
  };

  if (props.exported == false) {
    waitForElement("import_rivile_btn_" + props.id, function () {
      document.getElementById("import_rivile_btn_" + props.id).style.cssText =
        "block !important";
    });
  }

  return (
    <div
      className="modal fade"
      data-backdrop="static"
      id={props.status}
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className={`modal-dialog modal-edit ${hasPdfPreview ? "modal-fullscreen" : "modal-editOrders"}`}
        role="document"
      >
        <div className="modal-content" style={{ height: "100vh" }}>
          <div className="modal-header">
            <div className="col-md-6">
              <div className="row">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Invoice number <span className="text-orange">#</span>
                  {props.text}
                </h5>
              </div>
              {![43, 11].includes(props.supplier_id) && (
                <div className="row">
                  <span className="text-black">
                    <b>Order number: {props.sales_number}</b>
                  </span>
                </div>
              )}
              <div className="row">
                <span className="text-black">
                  <b>
                    Invoice date:{" "}
                    {moment(props.invoice_date).format("YYYY-MM-DD")}, Payment
                    made to: {moment(props.pay_due).format("YYYY-MM-DD")}
                  </b>
                </span>
              </div>
              {![43, 11].includes(props.supplier_id) && (
                <div className="row">
                  <span className="text-black">
                    <b>Deliver: {props.delivery_address}</b>
                  </span>
                </div>
              )}
              <div className="row">
                <span className="text-black">
                  <b>
                    Supplier:{" "}
                    <span className="text-orange">{props.supplier}</span>
                  </b>
                </span>
              </div>
              <div className="row">{props.store}</div>
            </div>
            <div className="col-md-6">
              <div className="row float-right">
                {showParseBtn && !showParseTypeDropdown && (
                  <button
                    id={`parse_btn_${props.id}`}
                    className="btn btn-sm float-right mr-3 d-flex justify-content-between btn-primary"
                    onClick={() => parseInvoice()}
                    disabled={props.loading}
                  >
                    {props.loading ? "Parsing..." : "Parse invoice"}
                  </button>
                )}
                {showParseBtn && showParseTypeDropdown && (
                  <div className="dropdown mr-3">

                    <button
                      id={`parse_btn_${props.id}`}
                      className="btn btn-sm btn-primary float-right mr-3 dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      disabled={props.loading}
                    >
                      {props.loading ? "Parsing..." : "Parse invoice"}
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      {parseTypeOptions.map((type) => (
                        <button
                          key={type.value}
                          type="button"
                          className="dropdown-item"
                          onClick={() => parseInvoice(type.value)}
                          disabled={props.loading}
                        >
                          {type.label}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                {showImportBtn && (
                  <button
                    id={`import_rivile_btn_${props.id}`}
                    className="btn btn-sm float-right mr-3 d-flex justify-content-between import_suppliers_inv_btn"
                    onClick={() => exportInvoice()}
                    disabled={props.loading}
                  >
                    {props.loading ? "Importing..." : "Import invoice"}
                  </button>
                )}
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  id="modalClose"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div
            className="modal-body"
            style={{ height: "100vh", overflow: "auto" }}
          >
            {hasPdfPreview ? (
              <div className="row">
                <div className="col-md-4" style={{ height: "calc(100vh - 160px)" }}>
                  <embed
                    src={props.suppliers_invoice_download_url}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    style={{ border: "1px solid #e9ecef" }}
                  ></embed>
                </div>
                <div className="col-md-8">{props.children}</div>
              </div>
            ) : (
              props.children
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuppliersInvoices;
